import { GET, POST, PUT, DELETE } from "./actions";
import {
  AUTH_API_URL,
  USER_API_URL,
  K8S_API_URL,
  PRIVATE,
  PRIVATE_REGISTRY,
  GIT_NEW_CREDENTIALS,
  REGISTRY_NEW_CREDENTIALS,
} from "./constants";

export function newProject(payload, callback) {
  const userRights = payload.selectedUsers?.map((it) => ({
    user: { id: it.id },
    isContributor: it.isContributor,
  }));
  const body = JSON.stringify({
    name: payload.name,
    userRights: userRights,
  });

  POST(
    "/k8s-project/",
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function updateProject(payload, callback) {
  const userRights = payload.selectedUsers?.map((it) => ({
    user: { id: it.id },
    isContributor: it.isContributor,
  }));
  const body = JSON.stringify({
    id: payload.id,
    name: payload.name,
    locked: payload.locked,
    userRights,
  });

  PUT(
    `/k8s-project/${payload.id}`,
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function deleteProject(payload, callback) {
  DELETE(
    `/k8s-project/${payload.id}`,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

//CUSTOMERS
export function getCustomers(callback) {
  GET("/customer/", "", (result, status) => {
    callback(status === 200 && result, status !== 200 && result?.message);
  });
}

export function createCustomer(form, callback) {
  const body = JSON.stringify({
    contactPersonName: form.name,
    contactPersonPhoneNumber: form.phone,
    contactPersonEmail: form.email,
    ...(form.comments ? { comments: form.comments } : {}),
  });

  POST("/customer/", body, (result, status) => {
    callback(status === 200 && result, status !== 200 && result?.message);
  });
}

export function updateCustomer(form, callback) {
  const body = JSON.stringify({
    id: form.id,
    contactPersonName: form.name,
    contactPersonPhoneNumber: form.phone,
    contactPersonEmail: form.email,
    ...(form.comments ? { comments: form.comments } : {}),
  });

  PUT(`/customer/${form.id}`, body, (result, status) => {
    callback(status === 200 && result, status !== 200 && result?.message);
  });
}

export function deleteCustomer(form, callback) {
  DELETE(`/customer/${form.id}`, (result, status) => {
    callback(status === 200 && result, status !== 200 && result?.message);
  });
}

//GOOGLE OAUTH
export function authWithGoogle(payload, callback) {
  POST(
    "/google",
    JSON.stringify(payload),
    (result, status) => {
      if (callback) {
        callback(result, status, status !== 200 && result?.message);
      }
    },
    AUTH_API_URL
  );
}

//GITHUB OAUTH
export function authWithGithub(payload, callback) {
  POST(
    "/github",
    JSON.stringify(payload),
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    AUTH_API_URL
  );
}

// Associate a CLI authCode with the caller's already-authenticated
// browser session. Used by /cli-login when hasValidToken() is true —
// avoids the double-login trap where the CliLogin page would redirect
// away before firing /google and the CLI would poll forever for a code
// that was never stored. See auth PR: /api/auth/associate-cli-code.
export function associateCliCode(authCode, callback) {
  POST(
    "/associate-cli-code",
    JSON.stringify({ authCode }),
    (result, status) => {
      if (callback) {
        callback(result, status, status !== 200 && (result?.message || result));
      }
    },
    AUTH_API_URL
  );
}

//LOCAL Login username&pwd
export function authWithCustomLogin(payload, callback) {
  POST(
    "/local",
    JSON.stringify(payload),
    (result, status) => {
      if (callback) {
        callback(result, status, status !== 200 && result?.message);
      }
    },
    AUTH_API_URL
  );
}

export function authWithOtherUser(payload, callback) {
  POST(
    `/${payload?.userId}/impersonate`,
    JSON.stringify(payload),
    (result, status) => {
      if (callback) {
        callback(result, status, status !== 200 && result?.message);
      }
    },
    AUTH_API_URL
  );
}

function downloadFile(blob, fileName) {
  let url = URL.createObjectURL(blob);
  let link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(url);
}

export function downloadCSV(form) {
  const categories = form?.categories?.map((it) => it.id).join(",");

  GET(`/question/csv`, { categories }, (result, status) => {
    if (status === 200) {
      downloadFile(result, "questions.csv");
    }
  });
}

//USERS
export function getUsers(callback, payload) {
  const endpoint = !payload?.shouldSearchByEmail
    ? "/user/"
    : `/user/email/${payload?.email}`;

  GET(
    endpoint,
    "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    USER_API_URL
  );
}

export function createUserWithGoogle(form, callback) {
  const body = JSON.stringify({
    clientId: form.clientId,
    credential: form.credential,
  });

  POST("/user/google", body, (result, status) => {
    callback(status === 200 && result, status !== 200 && result?.message);
  });
}

export function updateUser(form, callback) {
  const body = JSON.stringify({
    source: form.source,
    id: form.id,
    givenName: form.givenName,
    familyName: form.familyName,
    username: form.username,
    email: form.email,
    enabled: form.enabled,
    group: form.groups ?? [],
  });

  PUT(
    `/user/${form.id}`,
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    USER_API_URL
  );
}

export function deleteUser(form, callback) {
  DELETE(
    `/user/${form.id}`,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    USER_API_URL
  );
}

//PROJECTS
export function getProjects(callback) {
  GET(
    "/k8s-project/",
    "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function updateProjectLockedStatus(payload, callback) {
  POST(
    `/k8s-project/${payload?.id}/locked/${payload?.locked}`,
    "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function getk8sLogs(payload, callback) {
  GET(
    `/k8s-audit-log/${payload.objectName ? `${payload.objectName}/` : ""}${
      payload?.pageNumber
    }/${payload?.pageSize}`,
    "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function getBuilders(callback) {
  GET(
    "/k8s-builder/",
    "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function newBuild(payload, callback) {
  const body = JSON.stringify({
    displayName: payload.displayName,
    tag: payload.tag,
    serviceAccountName: payload.serviceAccountName,
    clusterStack: {
      name: payload?.clusterStack,
    },
    clusterStore: {
      name: payload?.clusterStore,
    },
    buildpackIds: payload.buildpackIds,
  });

  POST(
    "/k8s-builder/",
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function updateBuild(payload, callback) {
  const body = JSON.stringify({
    resourceVersion: payload.resourceVersion,
    tag: payload.tag,
    serviceAccountName: payload.serviceAccountName,
    clusterStack: {
      name: payload?.clusterStack,
    },
    clusterStore: {
      name: payload?.clusterStore,
    },
    buildpackIds: payload.buildpackIds,
  });

  PUT(
    `/k8s-builder/${payload.name}`,
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function deleteBuilder(name, callback) {
  DELETE(
    `/k8s-builder/${name}`,
    (result, status) => {
      callback &&
        callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function getImages(payload, callback) {
  GET(
    `/k8s-image/${payload?.name ? payload.name : ""}`,
    "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function getServices(callback) {
  GET(
    "/kn-service/",
    "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function newService(payload, callback) {
  const params = (paramN) =>
    payload?.[paramN]?.reduce((acc, currentVal) => {
      if (currentVal.key) {
        return { ...acc, [currentVal.key]: currentVal.value };
      }

      return acc;
    }, {});
  const configsAndSecrets = payload?.configs_values?.map((it) => it.name);
  const body = JSON.stringify({
    displayName: payload.displayName,
    saName: payload.saName,
    image: payload.image,
    containerPort: payload.containerPort,
    envParams: params("variables"),
    secretParams: params("secrets"),
    envFrom: configsAndSecrets,
    secretFrom: configsAndSecrets,
  });

  POST(
    "/kn-service/",
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function deleteService(name, clusterName, callback) {
  DELETE(
    clusterName
      ? `/kn-service/${name}/cluster/${clusterName}`
      : `/kn-service/${name}`,
    (result, status) => {
      callback &&
        callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function getConfig(callback) {
  GET(
    "/k8s-config/",
    "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function newConfig(payload, callback) {
  const envParams = payload?.variables?.reduce((acc, currentVal) => {
    return { ...acc, [currentVal.key]: currentVal.value };
  }, {});
  const body = JSON.stringify({
    displayName: payload.displayName,
    params: envParams,
  });

  POST(
    "/k8s-config/",
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function updateConfig(payload, callback) {
  const envParams = payload?.variables?.reduce((acc, currentVal) => {
    return { ...acc, [currentVal.key]: currentVal.value };
  }, {});
  const body = JSON.stringify({
    resourceVersion: payload?.metadata?.resourceVersion,
    params: envParams,
  });

  PUT(
    `/k8s-config/${payload?.name}`,
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function deleteConfig(name, callback) {
  DELETE(
    `/k8s-config/${name}`,
    (result, status) => {
      callback &&
        callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function getMetrics(payload, callback) {
  GET(
    `/metrics/realtime${payload?.name ? `/${payload.name}` : ""}`,
    "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function getServicesMetrics(payload, callback) {
  POST(
    `/metrics/services`,
    JSON.stringify(payload),
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function getBuildsMetrics(payload, callback) {
  POST(
    `/metrics/builds`,
    JSON.stringify(payload),
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function newImage(payload, callback) {
  const body = JSON.stringify({
    displayName: payload.displayName,
    tag: payload.tag,
    builder: payload.builderName,
    serviceAccountName: payload.serviceAccountName,
    git: {
      repo: payload.gitRepo,
      revision: payload.gitRevision,
    },
  });

  POST(
    "/k8s-image/",
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function updateImage(payload, callback) {
  const body = JSON.stringify({
    resourceVersion: payload.resourceVersion,
    tag: payload.tag,
    builder: payload.builderName,
    serviceAccountName: payload.serviceAccountName,
    git: {
      repo: payload.gitRepo,
      revision: payload.gitRevision,
    },
  });

  PUT(
    `/k8s-image/${payload.name}`,
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function deleteImage(name, callback) {
  DELETE(
    `/k8s-image/${name}`,
    (result, status) => {
      callback &&
        callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function forceRebuild(payload, callback) {
  POST(
    `/k8s-image/rebuild/${payload.name}`,
    null,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function restartService(payload, callback) {
  PUT(
    `/kn-service/${payload}/restart`,
    null,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function getServiceInstanceLogs(payload, callback) {
  GET(
    `/k8s-service/${payload.name}/instance-logs`,
    "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function getServiceCatalog(payload, callback) {
  GET(
    `/k8s-service-catalog/`,
    "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function newServiceCatalog(payload, callback) {
  const body = JSON.stringify(payload?.data);

  POST(
    `/k8s-service-catalog/${payload?.path}`,
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function getServiceCatalogByPath(payload, callback) {
  GET(
    `/k8s-service-catalog/instances${payload?.path ? `/${payload?.path}` : ""}`,
    "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

// Bind a Daari service to an app. Direct fetch because the shared POST
// helper doesn't compose extra query params — the POST wrapper always
// prepends its own "?" for the auto-attached appGroupId, so an
// endpoint of "…/bindings?restart=true" would end up "…?restart=true?
// appGroupId=…" — broken URL. Reuse the same auth + appGroupId
// conventions inline.
export function bindKnService(payload, callback) {
  const appName = payload?.appName;
  const bindingName = payload?.bindingName;
  const restart = payload?.restart !== false;
  if (!appName || !bindingName) {
    callback(null, "appName and bindingName are required");
    return;
  }
  const token = getTokenSafe();
  let appGroupId = null;
  try {
    const stored = sessionStorage.getItem("appGroupId");
    if (stored) appGroupId = JSON.parse(stored)?.id || null;
  } catch {
    /* ignore malformed sessionStorage */
  }
  const params = new URLSearchParams({ restart: restart ? "true" : "false" });
  if (appGroupId) params.append("appGroupId", appGroupId);
  fetch(
    `${K8S_API_URL}/kn-service/${encodeURIComponent(appName)}/bindings?${params.toString()}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({ name: bindingName }),
    }
  )
    .then(async (resp) => {
      const text = await resp.text();
      let body = null;
      try {
        body = text ? JSON.parse(text) : {};
      } catch {
        body = { message: text };
      }
      if (resp.ok) {
        callback(body, null);
      } else {
        callback(null, body?.message || `HTTP ${resp.status}`);
      }
    })
    .catch((e) => callback(null, e?.message || "Network error"));
}

// Local token accessor to keep this file's imports thin — utils.js
// intentionally doesn't import tokenStorage since GET/POST come from
// helpers/actions.js.
function getTokenSafe() {
  try {
    return localStorage.getItem("token") || null;
  } catch {
    return null;
  }
}

// Provision a NEW Daari service and bind it to an existing app in one
// atomic call (rollback on bind failure). Backed by coord PR #230.
// Body: { type: "<path>", name: "<service-name>" }.
export function provisionAndBindKnService(payload, callback) {
  const appName = payload?.appName;
  const type = payload?.type;
  const serviceName = payload?.serviceName;
  const restart = payload?.restart !== false;
  if (!appName || !type || !serviceName) {
    callback(null, "appName, type, and serviceName are required");
    return;
  }
  const token = getTokenSafe();
  let appGroupId = null;
  try {
    const stored = sessionStorage.getItem("appGroupId");
    if (stored) appGroupId = JSON.parse(stored)?.id || null;
  } catch {
    /* ignore */
  }
  const params = new URLSearchParams({ restart: restart ? "true" : "false" });
  if (appGroupId) params.append("appGroupId", appGroupId);
  fetch(
    `${K8S_API_URL}/kn-service/${encodeURIComponent(appName)}/services?${params.toString()}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({ type, name: serviceName }),
    }
  )
    .then(async (resp) => {
      const text = await resp.text();
      let body = null;
      try {
        body = text ? JSON.parse(text) : {};
      } catch {
        body = { message: text };
      }
      if (resp.ok) callback(body, null);
      else callback(null, body?.message || `HTTP ${resp.status}`);
    })
    .catch((e) => callback(null, e?.message || "Network error"));
}

// Unbind a Daari service from an app. Direct fetch (same reason as
// bindKnService — the shared POST wrapper doesn't compose extra query
// params). Backed by coord PR #229
// (DELETE /api/kn-service/{name}/bindings/{bindingKey}?restart=…).
export function unbindKnService(payload, callback) {
  const appName = payload?.appName;
  const bindingKey = payload?.bindingKey;
  const restart = payload?.restart !== false;
  if (!appName || !bindingKey) {
    callback(null, "appName and bindingKey are required");
    return;
  }
  const token = getTokenSafe();
  let appGroupId = null;
  try {
    const stored = sessionStorage.getItem("appGroupId");
    if (stored) appGroupId = JSON.parse(stored)?.id || null;
  } catch {
    /* ignore malformed sessionStorage */
  }
  const params = new URLSearchParams({ restart: restart ? "true" : "false" });
  if (appGroupId) params.append("appGroupId", appGroupId);
  fetch(
    `${K8S_API_URL}/kn-service/${encodeURIComponent(appName)}/bindings/${encodeURIComponent(bindingKey)}?${params.toString()}`,
    {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    }
  )
    .then(async (resp) => {
      const text = await resp.text();
      let body = null;
      try {
        body = text ? JSON.parse(text) : {};
      } catch {
        body = { message: text };
      }
      if (resp.ok) {
        callback(body, null);
      } else {
        callback(null, body?.message || `HTTP ${resp.status}`);
      }
    })
    .catch((e) => callback(null, e?.message || "Network error"));
}

// Project-scoped composite binding graph. One call returns both
// directions (apps→services + instances→apps) pre-joined so the
// console can render every card with O(1) lookups. Backed by coord
// PR #231 (GET /api/v1/binding-graph). appGroupId is auto-appended
// by the shared GET helper.
export function getBindingGraph(callback) {
  GET(
    "/v1/binding-graph",
    "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    }
  );
}

// Reverse lookup — list Daari services bound to a specific app.
// Backed by coord PR #228 (GET /api/kn-service/{name}/bindings).
// Returns an array of {kind, displayName, k8sName}.
// Kept for callers that only need one app; the graph endpoint above
// is the preferred path for dashboards.
export function getKnServiceBindings(payload, callback) {
  GET(
    `/kn-service/${payload?.name}/bindings`,
    "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

// Reverse lookup — list apps bound to a specific catalog instance.
// Backed by coord PR #227 (GET /k8s-service-catalog/instances/{path}/{name}/bindings).
// Returns an array of {kind, name} per DaariSecretRecord.BindingRef shape.
export function getInstanceBindings(payload, callback) {
  GET(
    `/k8s-service-catalog/instances/${payload?.path}/${payload?.name}/bindings`,
    "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function onDeleteCatalogByPath(payload, callback) {
  DELETE(
    `/k8s-service-catalog/${payload?.path}/${payload?.name}`,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function getClustersConfig(callback) {
  GET(`/k8s-cluster/`, "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function getClustersInstances(callback) {
  GET(
    `/k8s-cluster/instances`, "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function createClusterInstance(payload, callback) {
  const body = JSON.stringify(payload);

  POST(
    `/k8s-cluster/`,
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function onDeleteCluster(name, callback) {
  DELETE(
    `/k8s-cluster/${name}`,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function getServiceAccounts(callback) {
  GET(
    "/k8s-service-account/",
    "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function newServiceAccount(payload, callback) {
  const body = JSON.stringify({
    displayName: payload.displayName,
    secrets: payload.gitSecrets?.map((it) => it.name),
    imagePullSecrets: payload.registrySecrets?.map((it) => it.name),
  });

  POST(
    "/k8s-service-account/",
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function updateServiceAccount(payload, callback) {
  const body = JSON.stringify({
    resourceVersion: payload.resourceVersion,
    secrets: payload.gitSecrets?.map((it) => it.name),
    imagePullSecrets: payload.registrySecrets?.map((it) => it.name),
  });

  PUT(
    `/k8s-service-account/${payload.name}`,
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function deleteServiceAccount(name, callback) {
  DELETE(
    `/k8s-service-account/${name}`,
    (result, status) => {
      callback &&
        callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function getManageDb(callback) {
  GET(
    "/db/",
    "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function newManageDb(payload, callback) {
  const body = JSON.stringify({
    source: payload.db_source,
    type: payload.db_type,
    name: payload.db_name,
    password: payload.db_pwd,
  });

  POST(
    "/db/",
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function deleteManageDb(name, callback) {
  DELETE(
    `/db/${name}`,
    (result, status) => {
      callback &&
        callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function getGitSecrets(callback) {
  GET(
    "/k8s-secrets/git",
    "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function newGitSecrets(payload, callback) {
  const body = JSON.stringify({
    displayName: payload.displayName,
    username: payload.username,
    password: payload.password,
  });

  POST(
    "/k8s-secrets/git",
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function updateGitSecrets(payload, callback) {
  const body = JSON.stringify({
    resourceVersion: payload.resourceVersion,
    username: payload.username,
    password: payload.password,
  });

  PUT(
    `/k8s-secrets/git/${payload?.name}`,
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function deleteSecrets(name, callback) {
  DELETE(
    `/k8s-secrets/${name}/`,
    (result, status) => {
      callback &&
        callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function getOpaqueSecrets(callback) {
  GET(
    "/k8s-secrets/opaque",
    "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function newOpaqueSecrets(payload, callback) {
  const envParams = payload?.variables?.reduce((acc, currentVal) => {
    return { ...acc, [currentVal.key]: currentVal.value };
  }, {});
  const body = JSON.stringify({
    displayName: payload.displayName,
    secrets: envParams,
  });

  POST(
    "/k8s-secrets/opaque",
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function getRegistrySecrets(callback) {
  GET(
    "/k8s-secrets/registry",
    "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function newRegistrySecrets(payload, callback) {
  const body = JSON.stringify({
    displayName: payload.displayName,
    server: payload.server,
    username: payload.username,
    password: payload.password,
    ...(payload?.server?.includes(".amazonaws.com")
      ? { region: payload.region }
      : {}),
  });

  POST(
    "/k8s-secrets/registry",
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function updateRegistrySecrets(payload, callback) {
  const body = JSON.stringify({
    resourceVersion: payload.resourceVersion,
    server: payload.server,
    username: payload.username,
    password: payload.password,
    ...(payload?.server?.includes(".amazonaws.com")
      ? { region: payload.region }
      : {}),
  });

  PUT(
    `/k8s-secrets/registry/${payload.name}`,
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function getClusterStores(callback) {
  GET(
    "/k8s-cluster-store/",
    "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function newClusterStores(payload, callback) {
  const body = JSON.stringify({
    displayName: payload.displayName,
    images: payload.clusterStoreImages,
  });

  POST(
    "/k8s-cluster-store/",
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function updateClusterStores(payload, callback) {
  const body = JSON.stringify({
    resourceVersion: payload.resourceVersion,
    images: payload.clusterStoreImages,
  });

  PUT(
    `/k8s-cluster-store/${payload?.name}`,
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function deleteClusterStore(name, callback) {
  DELETE(
    `/k8s-cluster-store/${name}`,
    (result, status) => {
      callback &&
        callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function getClusterStacks(callback) {
  GET(
    "/k8s-cluster-stack/",
    "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function newClusterStacks(payload, callback) {
  const body = JSON.stringify({
    displayName: payload.displayName,
    id: payload.imageID,
    buildImage: payload.imageBuild,
    runImage: payload.imageRun,
  });

  POST(
    "/k8s-cluster-stack/",
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function updateClusterStacks(payload, callback) {
  const body = JSON.stringify({
    resourceVersion: payload.resourceVersion,
    id: payload.imageID,
    buildImage: payload.imageBuild,
    runImage: payload.imageRun,
  });

  PUT(
    `/k8s-cluster-stack/${payload.name}`,
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function deleteClusterStack(name, callback) {
  DELETE(
    `/k8s-cluster-stack/${name}`,
    (result, status) => {
      callback &&
        callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function setWizard3(payload, callback) {
  const params = (paramN) =>
    payload?.[paramN]?.reduce((acc, currentVal) => {
      if (currentVal.key) {
        return { ...acc, [currentVal.key]: currentVal.value };
      }

      return acc;
    }, {});

  const configsAndSecrets = payload?.configs_values?.map((it) => it.name);
  const body = JSON.stringify({
    displayName: payload.displayName,
    git: {
      repo: payload.git_repo,
      revision: payload.git_revision,
      accessType: payload.git_accessType,
      ...(payload.git_accessType === PRIVATE
        ? {
            secrets: {
              ...(payload?.git_secrets === GIT_NEW_CREDENTIALS
                ? {
                    username: payload.git_cred_username,
                    password: payload.git_cred_password,
                  }
                : {
                    name: payload?.git_cred_name,
                    displayName: payload?.git_cred_name,
                  }),
            },
          }
        : {}),
    },
    imagePullSecrets: {
      registryType: payload.registry_accessType,
      server: payload.registry_cred_server,
      ...(payload?.registry_cred_server?.includes(".amazonaws.com")
        ? { region: payload.registry_cred_region }
        : {}),
      ...(payload.registry_accessType === PRIVATE_REGISTRY
        ? {
            ...(payload?.registry_secrets === REGISTRY_NEW_CREDENTIALS
              ? {
                  displayName: payload.registry_name,
                  username: payload.registry_cred_username,
                  password: payload.registry_cred_password,
                }
              : {
                  name: payload?.registry_cred_name,
                  displayName: payload?.registry_cred_name,
                }),
          }
        : {}),
    },
    deployAutomatically: payload.deployAutomatically,
    service: {
      name: payload?.service_name,
      displayName: payload?.service_name,
      containerPort: payload?.container_port,
      envVars: {
        serviceBinding: {
          bindings: payload?.instancesCatalog?.map((it) => it.name),
        },
      },
      envParams: params("variables"),
      secretParams: params("secrets"),
      envFrom: configsAndSecrets,
      secretFrom: configsAndSecrets,
      scaleTo0: payload?.scaleTo0,
      dailyScaling: {
        up: payload?.up_time,
        down: payload?.down_time,
        timezone: payload?.timezone,
      },
      applicationSize: payload?.application_size,
    },
    deployNewDb: payload?.db_deploy,
    ...(payload?.db_deploy
      ? {
          db: {
            source: payload?.db_source,
            type: payload?.db_type,
            name: payload?.db_name,
            password: payload?.db_pwd,
          },
        }
      : {}),
  });

  POST(
    "/k8s/wizard-v3",
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function getConfigurationData2Export(payload, callback) {
  GET(
    `/k8s/app/${payload?.uid}`,
    "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function updateWizard3(payload, callback) {
  const params = (paramN) =>
    payload?.[paramN]?.reduce((acc, currentVal) => {
      if (currentVal.key) {
        return { ...acc, [currentVal.key]: currentVal.value };
      }

      return acc;
    }, {});

  const configsAndSecrets = payload?.configs_values?.map((it) => it.name);
  const body = JSON.stringify({
    displayName: payload.displayName,
    git: {
      repo: payload.git_repo,
      revision: payload.git_revision,
      accessType: payload.git_accessType,
      ...(payload.git_accessType === PRIVATE
        ? {
            secrets: {
              ...(payload?.git_secrets === GIT_NEW_CREDENTIALS
                ? {
                    username: payload.git_cred_username,
                    password: payload.git_cred_password,
                  }
                : {
                    name: payload?.git_cred_name,
                    displayName: payload?.git_cred_name,
                  }),
            },
          }
        : {}),
    },
    imagePullSecrets: {
      registryType: payload.registry_accessType,
      server: payload.registry_cred_server,
      ...(payload?.registry_cred_server?.includes(".amazonaws.com")
        ? { region: payload.registry_cred_region }
        : {}),
      ...(payload.registry_accessType === PRIVATE_REGISTRY
        ? {
            ...(payload?.registry_secrets === REGISTRY_NEW_CREDENTIALS
              ? {
                  displayName: payload.registry_name,
                  username: payload.registry_cred_username,
                  password: payload.registry_cred_password,
                }
              : {
                  name: payload?.registry_cred_name,
                  displayName: payload?.registry_cred_name,
                }),
          }
        : {}),
    },
    deployAutomatically: payload.deployAutomatically,
    service: {
      name: payload?.service_name,
      displayName: payload?.service_name,
      containerPort: payload?.container_port,
      envVars: {
        serviceBinding: {
          bindings: payload?.instancesCatalog?.map((it) => it.name),
        },
      },
      envParams: params("variables"),
      secretParams: params("secrets"),
      envFrom: configsAndSecrets,
      secretFrom: configsAndSecrets,
      scaleTo0: payload?.scaleTo0,
      dailyScaling: {
        up: payload?.up_time,
        down: payload?.down_time,
        timezone: payload?.timezone,
      },
      applicationSize: payload?.application_size,
    },
    deployNewDb: payload?.db_deploy,
    ...(payload?.db_deploy
      ? {
          db: {
            source: payload?.db_source,
            type: payload?.db_type,
            name: payload?.db_name,
            password: payload?.db_pwd,
          },
        }
      : {}),
  });

  PUT(
    `/k8s/wizard-v3/${payload?.displayName}`,
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function getBuilds(payload, callback) {
  GET(
    "/k8s/builds",
    payload?.imageName ? { imageName: payload?.imageName } : "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function fetchLogs(payload, callback) {
  const body = JSON.stringify({
    imageName: payload.imageName,
    buildNumber: payload.buildNumber,
  });

  POST(
    "/k8s/logs",
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function deleteBuild(name, callback) {
  DELETE(
    `/k8s/build/${name}`,
    (result, status) => {
      callback &&
        callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

// GUIDED SAMPLE APPS (Daari templates) — coordinator-owned catalog,
// distinct from the static data/samples.json starter drawer. Hits the
// general API_URL (already includes /api), not K8S_API_URL.
export function getAppTemplates(callback) {
  GET(
    "/v1/app-templates",
    "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    }
  );
}

export function getAppTemplate(slug, callback) {
  GET(
    `/v1/app-templates/${slug}`,
    "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    }
  );
}

export function createAppFromTemplate(payload, callback) {
  const body = JSON.stringify({
    projectId: payload?.projectId,
    appName: payload?.appName,
    templateSlug: payload?.templateSlug,
  });

  POST(
    "/v1/apps/from-template",
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    }
  );
}

export function getConfigsAndSecrets(callback) {
  GET(
    "/c2s-configs-and-secrets/",
    "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function neweConfigsAndSecrets(payload, callback) {
  const params = (paramN) =>
    payload?.[paramN]?.reduce((acc, currentVal) => {
      if (currentVal.key) {
        return { ...acc, [currentVal.key]: currentVal.value };
      }

      return acc;
    }, {});
  const body = JSON.stringify({
    displayName: payload.displayName,
    configs: params("variables"),
    secrets: params("secrets"),
  });

  POST(
    "/c2s-configs-and-secrets/",
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function updateConfigsAndSecrets(payload, callback) {
  const params = (paramN) =>
    payload?.[paramN]?.reduce((acc, currentVal) => {
      if (currentVal.key) {
        return { ...acc, [currentVal.key]: currentVal.value };
      }

      return acc;
    }, {});
  const body = JSON.stringify({
    resourceVersion: payload?.metadata?.resourceVersion,
    configs: params("variables"),
    secrets: params("secrets"),
  });

  PUT(
    `/c2s-configs-and-secrets/${payload?.name}`,
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function deleteConfigsAndSecrets(name, callback) {
  DELETE(
    `/c2s-configs-and-secrets/${name}`,
    (result, status) => {
      callback &&
        callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function getSecret(payload, callback) {
  GET(
    `/c2s-secret/${payload.name}/${payload.key}`,
    "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function deleteApplication(uid, callback) {
  DELETE(
    `/k8s/app/${uid}`,
    (result, status) => {
      callback &&
        callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function renameApplication(oldName, newName, callback) {
  const body = JSON.stringify({
    oldName,
    newName,
  });

  POST(
    "/k8s/app/rename",
    body,
    (result, status) => {
      callback &&
        callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function getAppByImageUid(payload, callback) {
  GET(
    `/k8s/app/${payload}`,
    "",
    (result, status) => {
      callback &&
        callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function updatePassword(form, callback) {
  const body = JSON.stringify({
    password: form.password,
  });

  PUT(
    `/user/${form.id}/password`,
    body,
    (result, status) => {
      callback &&
        callback(status === 200 && result, status !== 200 && result?.message);
    },
    USER_API_URL
  );
}

export function getBuildLogs(payload, callback) {
  GET(
    `/k8s/pod-logs/${payload.podName}`,
    "",
    (result, status) => {
      callback &&
        callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function getRoles(callback) {
  GET(
    "/role/",
    "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    USER_API_URL
  );
}

export function getAccounts(payload, callback) {
  let url = "/account/";

  if (payload?.accountId) {
    url += payload.accountId;
  } else if (!isNaN(payload?.pageNumber) && payload?.pageSize) {
    url += `${payload.pageNumber}/${payload.pageSize}`;
  }

  GET(
    url,
    "",
    (result, status) => {
      callback(
        status === 200 ? result : null,
        status !== 200 ? result?.message : null
      );
    },
    USER_API_URL
  );
}

export function createAccount(form, callback) {
  const body = JSON.stringify({
    name: form?.accountName,
    enabled: form?.enabled,
    billingEnabled: form?.billingEnabled,
    ownerUser: {
      username: form.username,
      email: form.email,
      userType: form.userType,
      givenName: form.givenName,
      familyName: form.familyName,
      source: form.source,
      password: form.password,
    },
  });

  POST(
    "/account/",
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    USER_API_URL
  );
}

export function updateAccount(form, callback) {
  const body = JSON.stringify({
    id: form.id,
    name: form?.accountName,
    enabled: form?.enabled,
    billingEnabled: form?.billingEnabled,
  });

  PUT(
    `/account/${form.id}`,
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    USER_API_URL
  );
}

export function deleteAccount(form, callback) {
  DELETE(
    `/account/${form.id}`,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    USER_API_URL,
    form.deleted && { cleanup: true }
  );
}

export function getAccountUsers(payload, callback) {
  GET(
    `/user/account/${payload?.id}`,
    "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    USER_API_URL
  );
}

export function createAccountUser(payload, callback) {
  const body = JSON.stringify({
    username: payload.username,
    email: payload.email,
    enabled: payload.enabled,
    givenName: payload.givenName,
    familyName: payload.familyName,
    source: payload.source,
    password: payload.password,
    groups: payload?.groups ?? [],
  });

  POST(
    `/user/account/${payload?.accountId}`,
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    USER_API_URL
  );
}

export function getAccountGroups(payload, callback) {
  GET(
    `/group/account/${payload?.id}`,
    "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    USER_API_URL
  );
}

export function createAccountGroup(payload, callback) {
  const body = JSON.stringify({
    name: payload.name,
    accountId: payload.accountId,
    userRole: { id: payload.roleId },
    enabled: payload?.enabled,
  });

  POST(
    `/group/`,
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    USER_API_URL
  );
}

export function updateAccountGroup(payload, callback) {
  const body = JSON.stringify({
    name: payload.name,
    accountId: payload.accountId,
    userRole: { id: payload.roleId },
    enabled: payload.enabled,
  });

  PUT(
    `/group/${payload.id}`,
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    USER_API_URL
  );
}

export function disableAccount(payload, callback) {
  const body = JSON.stringify({
    id: payload.id,
    status: payload.status,
  });
  POST(
    `/account/${payload.id}/status/${payload.status}`,
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    USER_API_URL
  );
}

export function getNotifications(payload, callback) {
  GET(
    `/notifications/${payload?.pageNumber}/${payload?.pageSize}`,
    "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function setNotifications2Read(payload, callback) {
  const body = JSON.stringify(payload);

  POST(
    "/notifications/read",
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

// RBAC - User Permissions
export function getUserPermissions(callback) {
  GET(
    "/user/me/permissions",
    "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    USER_API_URL
  );
}

// RBAC - Custom Roles
export function createRole(payload, callback) {
  const body = JSON.stringify({
    name: payload.name,
    description: payload.description,
    scope: payload.scope,
    accountId: payload.accountId,
    permissions: payload.permissions,
    isCustom: true,
  });

  POST(
    "/role/",
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    USER_API_URL
  );
}

export function updateRole(payload, callback) {
  const body = JSON.stringify({
    id: payload.id,
    name: payload.name,
    description: payload.description,
    permissions: payload.permissions,
  });

  PUT(
    `/role/${payload.id}`,
    body,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    USER_API_URL
  );
}

export function deleteRole(payload, callback) {
  DELETE(
    `/role/${payload.id}`,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    USER_API_URL
  );
}

// RBAC - Group delete
export function deleteGroup(payload, callback) {
  DELETE(
    `/group/${payload.id}`,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    USER_API_URL
  );
}

// RBAC - Permissions list
export function getPermissions(callback) {
  GET(
    "/permission/",
    "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    USER_API_URL
  );
}

// ==================== DOMAINS ====================

export function getPlatformDomains(callback) {
  GET(
    "/domains/platform",
    "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function getDomains(projectId, callback) {
  GET(
    "/domains/",
    { projectId },
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function registerDomain(payload, callback) {
  POST(
    "/domains/",
    JSON.stringify({
      domain: payload.domain,
      projectId: payload.projectId,
      dnsMethod: payload.dnsMethod,
    }),
    (result, status) => {
      callback(status === 200 || status === 201 ? result : null, status !== 200 && status !== 201 ? result?.message : null);
    },
    K8S_API_URL
  );
}

export function checkDomainStatus(domain, callback) {
  GET(
    `/domains/${domain}/status`,
    "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function deleteDomainApi(domainId, callback) {
  DELETE(
    `/domains/${domainId}`,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function getDomainAssignments(projectId, callback, appName) {
  const params = { projectId };
  if (appName) params.appName = appName;
  GET(
    "/domains/assignments",
    params,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

export function assignDomainApi(payload, callback) {
  POST(
    "/domains/assignments",
    JSON.stringify({
      subdomain: payload.subdomain,
      domain: payload.domain,
      appName: payload.appName,
      projectId: payload.projectId,
    }),
    (result, status) => {
      callback(status === 200 || status === 201 ? result : null, status !== 200 && status !== 201 ? result?.message : null);
    },
    K8S_API_URL
  );
}

export function unassignDomainApi(assignmentId, callback) {
  DELETE(
    `/domains/assignments/${assignmentId}`,
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    K8S_API_URL
  );
}

// RBAC - Audit Logs
export function getAuditLogs(payload, callback) {
  let url = "/audit/";

  if (payload?.userId) {
    url = `/audit/users/${payload.userId}`;
  } else if (payload?.resourceType && payload?.resourceId) {
    url = `/audit/resources/${payload.resourceType}/${payload.resourceId}`;
  } else if (payload?.pageNumber !== undefined && payload?.pageSize) {
    url = `/audit/${payload.pageNumber}/${payload.pageSize}`;
  }

  GET(
    url,
    payload?.filters || "",
    (result, status) => {
      callback(status === 200 && result, status !== 200 && result?.message);
    },
    USER_API_URL
  );
}
